import React from 'react';
import { components, OptionProps } from 'react-select';
import Option from '../types/option';
import '../filters.scss';

const MatchedOption = (properties: OptionProps<Option, true>) => {
  const { children, data } = properties;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.Option {...properties}>
      <span className="dvinci-filter-option-value">{children}</span>
      <span className="dvinci-filter-option-match-count badge">{data.matches}</span>
    </components.Option>
  );
};

export default MatchedOption;
